import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Hook to handle Electron menu commands (navigation and playback)
 *
 * This hook listens for IPC messages from the Electron main process
 * and dispatches appropriate actions in the renderer.
 *
 * Navigation commands are handled directly via React Router.
 * Playback commands dispatch custom events that the player can listen for.
 */
export function useElectronMenu(): void {
  const navigate = useNavigate();

  useEffect(() => {
    const electronAPI = globalThis.window?.electronAPI;
    if (!electronAPI) return;

    // Handle navigation commands from menu
    electronAPI.onNavigate((path: string) => {
      navigate(path);
    });

    // Handle playback commands from menu
    // Dispatch custom events that the player component listens for
    electronAPI.onPlayback((action: string) => {
      const event = new CustomEvent("electron-playback", { detail: { action } });
      globalThis.dispatchEvent(event);
    });
  }, [navigate]);
}
